// These rules are scoped to body.talo-app-active. Keep the stylesheet loaded
// between pages so entering the journey does not download it after first paint.
export const ensureJourneyStyles = () => {
  const existing = document.querySelector<HTMLLinkElement>('link[data-ed-journey-styles]');
  if (existing) return existing;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/talo-next/ed-journey.css';
  link.dataset.edJourneyStyles = 'true';
  // A failed download must not prevent a later visit from trying again.
  link.addEventListener('error', () => link.remove(), { once: true });
  link.addEventListener(
    'load',
    () => {
      link.dataset.edJourneyLoaded = 'true';
    },
    { once: true }
  );
  document.head.appendChild(link);
  return link;
};
